const state = {
  /** 卖家信息 */
  sellerInfo: {
    /** 卖家编号 */
    sellerNo: undefined,
    /** 卖家证件号 */
    sellerCertNo: undefined,
    /** 卖家名称 */
    sellerName: undefined,
    /** 店铺名称 */
    storeName: undefined,
    /** 店铺链接 */
    storeUrl: undefined,
    /** 实体类型 */
    entityType: undefined,
    /** 回调地址 */
    backlinkUrl: undefined,
    /** 店铺平台ID */
    platformId: undefined,
    /** 店铺平台名称 */
    platformName: undefined,
    /** 店铺平台链接 */
    platformUrl: undefined,
    /** 实体ID */
    entityId: undefined,
    /** 店铺ID */
    shopId: undefined
  },
  /** 实体列表 */
  entityList: [],
  /** 当前所选实体对象 */
  currentSelectedEntity: {},
  /** 直接绑定结果 */
  directBindingResult: undefined,
  /** 直接绑定的错误信息 */
  bindingErrorInfo: '',
  /** 实体列表无可用实体 */
  allRecordsDisable: false
}

const mutations = {
  /** 设置卖家信息 */
  setSellerInfo(state, newMap) {
    state.sellerInfo = { ...state.sellerInfo, ...newMap };
  },
  /** 设置实体列表 */
  setEntityList(state, newArr) {
    state.entityList = [...newArr];
  },
  /** 设置当前所选实体对象 */
  setCurrentSelectedEntity(state, newVal) {
    state.currentSelectedEntity = { ...newVal };
  },
  /** 设置直接绑定页面绑定结果 */
  setDirectBindingResult(state, newVal) {
    state.directBindingResult = newVal;
  },
  /** 设置绑定结果错误信息 */
  setBindingErrorInfo(state, newVal) {
    state.bindingErrorInfo = newVal;
  },
  /** 设置是否实体列表无可用实体 */
  setAllRecordsDisable(state, newVal) {
    state.allRecordsDisable = newVal;
  }
}

export default ({
  namespaced: true,
  state,
  // getters,
  // actions,
  mutations
})